import { gql } from '@src/lib/gql'

export const UPSERT_ADVISOR_PROFILE = gql`
  mutation UpsertAdvisorProfile($input: UpsertAdvisorProfileInput!) {
    upsertAdvisorProfile(input: $input) {
      advisorProfile {
        id
        advisorProfileId
        statusKey
        isApproved
        headline
        categoryKeys
        notableBrands
        engagementStyleKeys
        skillTagTitles
        advisingNote
        preferredCompensationTypeKeys
        sessionBookingUrl
        hourlyRate
        isSessionEnabled
        timezone
        sessionWeeklyHours
        sessionFeeWaiveCode
        canAcceptSessions
      }
    }
  }
`
